import { put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import toastr from '../../helpers/toastr';
import AnalyticsClient from '../../analytics/analyticsClient';
import trackEvents from '../../analytics/trackEvents';
import { selectToken } from '../selectors';

export function* approveRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/approvals/approve`,
      method: 'PUT',
      token: selectToken(store.getState()),
      data: payload.data.data,
    });
    yield put(actions.approveRequestSuccess({ res, payloadData: payload.data.data }));
    payload.data.cb && payload.data.cb();
    yield put(actions.getTodoApprovalsRequest());
    yield put(actions.getDoneApprovalsRequest());
    if (payload.data.data.entries) {
      toastr.success(`${payload.data.data.entries.length} time entries approved.`);
      AnalyticsClient.track(trackEvents.APPROVE_TIMESHEET_ENTRIES);
    } else {
      toastr.success(`${payload.data.data.timesheets.length} timesheets approved.`);
      AnalyticsClient.track(trackEvents.APPROVE_TIMESHEET);
    }
  } catch (error) {
    yield put(actions.approveRequestFailure(error));
  }
}

export function* declineRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/approvals/decline`,
      method: 'PUT',
      token: selectToken(store.getState()),
      data: payload.data.data,
    });
    yield put(actions.declineRequestSuccess({ res, payloadData: payload.data.data }));
    payload.data.cb && payload.data.cb();
    yield put(actions.getTodoApprovalsRequest());
    yield put(actions.getDoneApprovalsRequest());
    if (payload.data.data?.entries) {
      toastr.success(`${payload.data.data.entries.length} time entries declined.`);
      AnalyticsClient.track(trackEvents.DECLINE_TIMESHEET_ENTRIES);
    } else {
      toastr.success(`${payload.data.data.timesheets.length} timesheets declined.`);
      AnalyticsClient.track(trackEvents.DECLINE_TIMESHEET);
    }
  } catch (error) {
    yield put(actions.declineRequestFailure(error));
  }
}

export function* getDoneApprovalsRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/approvals${payload.data?.groupBy ? `?groupBy=${payload.data.groupBy}` : ''}`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getDoneApprovalsRequestSuccess({ res, groupBy: payload.data?.groupBy }));
  } catch (error) {
    yield put(actions.getDoneApprovalsRequestFailure({ error, groupBy: payload.data?.groupBy }));
  }
}

export function* getTodoApprovalsRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/approvals?current=true${payload.data?.groupBy ? `&groupBy=${payload.data.groupBy}` : ''}`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getTodoApprovalsRequestSuccess({ res, groupBy: payload.data?.groupBy }));
  } catch (error) {
    yield put(actions.getTodoApprovalsRequestFailure({ error, groupBy: payload.data?.groupBy }));
  }
}
